<template>
  <form
    class="form-edit-user"
    @submit.prevent="onSubmit">
    <div class="form-edit-user__row">
      <input-text
        title="Фамилия"
        v-bind:violations="surnameInputErrors"
        v-model="profile.surname" />
      <input-text
        title="Имя"
        v-bind:violations="nameInputErrors"
        v-model="profile.name" />
      <input-text
        title="Отчество"
        v-bind:violations="patronymicInputErrors"
        v-model="profile.patronymic" />
    </div>
    <input-text
      title="E-mail"
      v-bind:violations="emailInputErrors"
      v-model="profile.email" />
    <menu class="form-edit-user__buttons">
      <button
        class="form-edit-user__button-cancel"
        type="button"
        v-on:click="onCancel">Отмена</button>
      <button
        class="form-edit-user__button-save"
        type="submit">Сохранить</button>
    </menu>
  </form>
</template>

<script>
import { UserProfile } from '@/storage/gateways/UserGateway';
import InputText from '@/components/InputText.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

export default {
  components: { InputText },
  computed: {
    nameInputErrors: resolveInputErrors('name'),
    patronymicInputErrors: resolveInputErrors('patronymic'),
    surnameInputErrors: resolveInputErrors('surname'),
    emailInputErrors: resolveInputErrors('email'),
  },
  data() {
    return {
      profile: new UserProfile(
        this.initialProfile.email,
        this.initialProfile.name,
        this.initialProfile.patronymic,
        this.initialProfile.surname,
        this.initialProfile.photo_url,
      ),
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.profile);
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
  props: {
    /**
     * @description Профиль.
     * @type {UserProfile}
     */
    initialProfile: { type: UserProfile, required: true },
    /**
     * @description Нарушения ограничений.
     * @type {any}
     */
    inputErrors: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.form-edit-user {
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  gap: 10px;
  &__row {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
  &__buttons {
    display: flex;
    flex-direction: row;
    margin: 50px 0 0 auto;
    gap: 10px;
    justify-content: flex-end;
    max-width: 438px;
    width: 100%;
  }
  &__button {
    &-cancel {
      max-width: 219px;
      @include buttons.btn-transparent(100%, 56px, 20px);
    }
    &-save {
      max-width: 219px;
      @include buttons.btn-blue(100%, 56px, 20px);
    }
  }
}
</style>
